// extracted by mini-css-extract-plugin
module.exports = {"wsi9ir8":"wsi9ir8","cse0lxf":"cse0lxf"};